<template>
  <div class="sjwx">
    <div class="top">
      <img src="../assets/images/txt.png" alt />
    </div>
    <div class="container">
      <side-bar @getTabActive="getTabActive"></side-bar>
      <div class="right">
        <info-tip></info-tip>
        <right-title :titleText="titleText"></right-title>
        <div class="condition_box">
          <search-form @shidianClick="shidianClick" @yuefenClick="yuefenClick"></search-form>
          <export-tool v-if="tableTbodyData.length>0" @exportImg="exportImg" @exportExcel="exportExcel"></export-tool>
        </div>
        <bar-line-chart :chartDt="chartDt" :xAxisData="xAxisData" :titleText="titleText" :theadDataSort="theadDataSort" @load="getChartImgSrc"></bar-line-chart>
        <table-con :thead="tableTheadData" :tbody="tableTbodyData" @theadCheck="theadCheck"></table-con>
        <target-desc></target-desc>
      </div>
    </div>
    <footer-con></footer-con>
  </div>
</template>

<script setup>
  import rightTitle from '../components/rightTitle.vue';
  import infoTip from '../components/infoTip.vue';
  import sideBar from '../components/sideBar.vue';
  import targetDesc from '../components/targetDesc.vue';
  import footerCon from '../components/footerCon.vue';
  import searchForm from '../components/searchForm.vue';
  import exportTool from '../components/exportTool.vue';
  import barLineChart from '../components/barLineChart.vue';
  import tableCon from '../components/tableCon.vue';
  import axios from 'axios';
  import { ref, watch } from 'vue';
  import { useStore } from 'vuex';
  import { exportSetting } from '../utils/tools';
  import { getTableData, getTableHeadData } from '../services/service';

  const store = useStore();
  let imgSrc = ref(null);
  let tableTheadData = ref(null);
  let tableTbodyData = ref([]);
  let chartAllData = ref(null);
  let chartDt = ref({});
  let xAxisData = ref([]);
  let titleText = ref('');
  let shidian = ref('time');
  let yuefen = ref('12');
  let tabActive = ref('');
  let theadDataSort = ref([]);

  const getTabActive = (val) => {
    tabActive.value = val;
  };
  const getChartImgSrc = (src) => {
    imgSrc.value = src;
  };
  const exportImg = () => {
    let img = new Image();
    img.src = imgSrc.value;

    img.onload = () => {
      let canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      let dataURL = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      // 创建一个单击事件
      let event = new MouseEvent('click');
      // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
      a.download = titleText.value;
      // 将生成的URL设置为a.href属性
      a.href = dataURL;
      // 触发a的单击事件
      a.dispatchEvent(event);
    };
  };
  // 导出excel
  const exportExcel = () => {
    let headData = LAY_EXCEL.tableToJson(document.getElementsByClassName('el-table__header')[0]).head;
    let bodyData = LAY_EXCEL.tableToJson(document.getElementsByClassName('el-table__body')[0]).body;
    exportSetting(headData, bodyData, tableTheadData.value, titleText.value);
  };

  // ---------------------------------
  const resetVar = () => {
    tableTheadData.value = [];
    tableTbodyData.value = [];
    chartAllData.value = [];
    xAxisData.value = [];
    chartDt.value = {};
    theadDataSort.value = [];
  };
  const loadTableAndChart = () => {
    let id = store.state.targetId.split('-')[0];
    let searchType = shidian.value;
    let timeType = store.state.dtType;
    let timeScope = timeType == 'MM' ? yuefen.value : 5;
    titleText.value = store.state.crumbs.split(',').pop() || '';

    let headParams = { id, searchType, timeScope, dataType: tabActive.value, timeType };
    // if (searchType == 'area') headParams.timeType = timeType;

    let bodyParams = { id, timeType, searchType, timeScope, ndjd: tabActive.value };

    // 2022.06.02 优化 --------------------------------
    getTableHeadData(headParams).then((theadRs) => {
      resetVar();
      if (theadRs && theadRs.length > 0) {
        getTableData(bodyParams, theadRs).then((bodyRs) => {
          tableTheadData.value = theadRs;
          tableTbodyData.value = bodyRs['data'];
          // echart 图表默认加载
          if (tableTbodyData.value.length > 0) {
            let cityName = theadRs[1]['colCode'];
            chartAllData.value = bodyRs['chartData'];
            xAxisData.value = chartAllData.value['xAxisData'];
            chartDt.value = { [cityName]: chartAllData.value[cityName] };
            theadDataSort.value = bodyRs['theadDataSort'];
          } else {
            resetVar();
          }
        });
      }
    });
    // 2022.06.02 优化 --------------------------------
  };
  const shidianClick = (sd) => {
    shidian.value = sd;
    loadTableAndChart();
  };
  const yuefenClick = (m) => {
    yuefen.value = m;
    loadTableAndChart();
  };
  const theadCheck = (list) => {
    // echart 图表根据选择列加载
    chartDt.value = {};
    for (const key in list) {
      if (list[key]) {
        chartDt.value[key] = chartAllData.value[key];
      }
    }
  };

  watch(
    () => store.state.targetId,
    (nv) => {
      loadTableAndChart();
    }
  );
</script>

<style lang="less" scoped>
  .sjwx {
    background: url('../assets/images/bg.png') no-repeat scroll center top #ffffff;
    background-size: contain;
  }
  .top {
    display: flex;
    width: var(--container-width);
    height: 155px;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
  }
  .container {
    display: flex;
    width: var(--container-width);
    margin: 0 auto;
    box-shadow: 0 0 10px rgba(99, 99, 99, 0.2);
  }
  .right {
    flex: 1;
    width: 0;
    padding-bottom: 20px;
    background-color: #fff;
  }
  .condition_box {
    display: flex;
    padding: 20px 35px;
    align-items: center;

    .search_box {
      flex: 1;
    }
  }
</style>